import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true})
@Injectable()
export class FuseMatchMediaService implements OnDestroy {
    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');
    mediaObserver$: Subscription;

    constructor(private mediaObserver: MediaObserver) {
        this.activeMediaQuery = '';

        this.mediaObserver$ = this.mediaObserver.asObservable().subscribe((change: MediaChange[]) => {
            change.forEach((c) => {
                if ( this.activeMediaQuery !== c.mqAlias ) {
                    this.activeMediaQuery = c.mqAlias;
                    this.onMediaChange.next(c.mqAlias);
                }
            });
        });
    }

    ngOnDestroy(): void {
        this.onMediaChange?.unsubscribe();
        this.mediaObserver$?.unsubscribe();
    }
}
